<div class="inline-image-nav">
  <digital-platform-inline-image
    [webpMedia]="webpMedia"
    [url]="url"
    class="d-block mb-4"
  ></digital-platform-inline-image>

  <digital-platform-rsx-a
    *ngIf="config.link_image_overlay === '0'"
    [url]="config.link_url || ''"
    [klass]="linkStyles"
    [attr.data-automation-id]="config.link_title"
    >{{ config.link_title }}</digital-platform-rsx-a
  >

  <digital-platform-cta-button
    *ngIf="config.link_image_overlay === '1'"
    style="position: absolute; bottom: 20px; left: 5px; right: 5px"
    [ctaStyle]="imageCtaLinkStyle"
    [attr.data-automation-id]="config.link_title"
    [url]="getImageCtaLinkUrl(config.link_url !== null ? config.link_url : '')"
    >{{ config.link_title }}</digital-platform-cta-button
  >
</div>
